import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import './styles.css';
import Icons from '../../data/constants/Icons';
import * as React from "react";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import { Collapse } from '@mui/material';

export const CustomDrawer = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) element.scrollIntoView({ behavior: 'smooth' });
        }
    }, [location]);

    const isActive = (path: string) => {
        return location.pathname === path;
    };


    return (
        <div>
            <IconButton edge="start" onClick={() => setOpen(true)}>
                <Icons.Drawer width={"30px"} color={open ? "var(--dark-blue)" : ""} />
            </IconButton>

            <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
                <Box sx={{ width: 250, position: "relative" }}>
                    <IconButton
                        onClick={() => setOpen(false)}
                        sx={{ position: "absolute", top: 8, left: 8 }}
                    >
                        <Icons.Close />
                    </IconButton>

                    <List sx={{ mt: 6 }}>
                        <ListItem disablePadding>
                            <ListItemButton
                                component={Link}
                                to="/"
                                onClick={() => setOpen(false)}
                            >
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <span
                                            className={`drawer-link ${isActive("/") ? "active" : ""}`}
                                        >
                                            {t("default_home")}
                                        </span>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton component={Link}
                                to="/ironing"
                                onClick={() => setOpen(false)}>
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <span className={`drawer-link ${isActive("/ironing") ? "active" : ""}`}>
                                            {t("default_ironing")}
                                        </span>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>

                        <Collapse in={true} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItemButton
                                    component={Link}
                                    to="/ironing#washingIroningDryClean"
                                    onClick={() => setOpen(false)}
                                    sx={{ pl: 4 }}
                                >
                                    <ListItemText
                                        disableTypography
                                        primary={<span className={`drawer-link ${isActive("/ironing#washingIroningDryClean") ? "active" : ""}`}>{t("washing_ironing_dry_clean")}</span>}
                                    />
                                </ListItemButton>

                                <ListItemButton
                                    component={Link}
                                    to="/ironing#ironingPackagesTableSection"
                                    onClick={() => setOpen(false)}
                                    sx={{ pl: 4 }}
                                >
                                    <ListItemText
                                        disableTypography
                                        primary={<span className="drawer-link sub-link">{t("ironing_package")}</span>}
                                    />
                                </ListItemButton>

                                <ListItemButton
                                    component={Link}
                                    to="/ironing#ironingTableSection"
                                    onClick={() => setOpen(false)}
                                    sx={{ pl: 4 }}
                                >
                                    <ListItemText
                                        disableTypography
                                        primary={<span className="drawer-link sub-link">{t("ironing")}</span>}
                                    />
                                </ListItemButton>
                            </List>
                        </Collapse>

                        <ListItem disablePadding>
                            <ListItemButton
                                component={Link}
                                to="/sewing"
                                onClick={() => setOpen(false)}
                            >
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <span
                                            className={`drawer-link ${isActive("/sewing") ? "active" : ""}`}
                                        >
                                            {t('default_sewing')}
                                        </span>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>

                        <ListItem disablePadding>
                            <ListItemButton
                                component={Link}
                                to="/dryCleaning"
                                onClick={() => setOpen(false)}
                            >
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <span
                                            className={`drawer-link ${isActive("/dryCleaning") ? "active" : ""}`}
                                        >
                                            {t('dry_cleaning')}
                                        </span>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>


                        <ListItem disablePadding>
                            <ListItemButton
                                component={Link}
                                to="/#infoSchedule"
                                onClick={() => setOpen(false)}
                            >
                                <ListItemText
                                    disableTypography
                                    primary={
                                        <span
                                            className={`drawer-link ${isActive("/#infoSchedule") ? "active" : ""}`}
                                        >
                                            {t('default_contacts')}
                                        </span>
                                    }
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
        </div>
    );
};

export default CustomDrawer;
